// import VueRouter from 'vue-router'
import {createRouter,createWebHashHistory} from 'vue-router'



const RouterList = [
    {
        path: '/',
        name:'home',
        component: () => import('@/views/index/index')
    },
    {
        path: '/pay',
        name:'pay',
        component: () => import('@/views/testpay/index')
    },
    {
        path: '/clientpay',
        name:'clientpay',
        component: () => import('@/views/testpay/ClientPayment.vue')
    },
    {
        path: '/pay/success',
        name:'success',
        component: () => import('@/views/pay/SuccessPage')
    },
    {
        path: '/test/pay',
        name:'testpay',
        component: () => import('@/views/testpay/index')
    },
    {
        path: '/test/clientpay',
        name:'testclientpay',
        component: () => import('@/views/testpay/ClientPayment.vue')
    },
    {
        path: '/wechat/oauth',
        name:'wechatOAuth',
        component: () => import('@/views/WechatOAuth/index')
    },
]

const Routers = createRouter({
    history:createWebHashHistory(),
    routes:RouterList
})
export  {
    Routers
}


// const createRouter = () => new VueRouter({
//     routes: RouterList
// });
//
//
// const router = createRouter()
//
//
//
// export default router
